import { createContext, useContext, useState } from 'react';

const QueryHistoryOverlayContext = createContext();

export const useQueryHistoryOverlay = () => {
  const context = useContext(QueryHistoryOverlayContext);
  if (!context) throw new Error('useQueryHistoryOverlay must be used within QueryHistoryOverlayProvider');
  return context;
};

export const QueryHistoryOverlayProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const openOverlay = (options = {}) => {
    setIsOpen(true);
    setIsMinimized(options.minimized || false);
  };
  const closeOverlay = () => { setIsOpen(false); setIsMinimized(false); };
  const toggleMinimized = () => setIsMinimized(prev => !prev);

  return (
    <QueryHistoryOverlayContext.Provider value={{ isOpen, isMinimized, openOverlay, closeOverlay, toggleMinimized }}>
      {children}
    </QueryHistoryOverlayContext.Provider>
  );
};
